export default "__VITE_ASSET__C0Wv0moX__"